const data = {
  practiceName: null,
  bookings: [],
  locations: [],
  timezone: null,
  currentLocation: {
    location: null,
    bookings: [],
  },
  currentDay: null,
  patientInfo: null,
  appointmentInfo: null,
  calendarStart: null,
  calendarEnd: null,
  loadedUntil: null,
  orthoConfirm: null,
};

export default data;



// WEBPACK FOOTER //
// ./src/data.js